// Test IDs for LXRA Intelligence (Session Planner + Creative Blueprint) and
// the photographer-facing Intelligence / Leads dashboard tabs.

export const PLANNER_PAGE = {
  root: 'planner-page',
  stepIndicator: 'planner-step-indicator',
  step: (n) => `planner-step-${n}`,
  serviceSelect: 'planner-service-select',
  occasionInput: 'planner-occasion-input',
  dateInput: 'planner-date-input',
  timeOption: (v) => `planner-time-${v}`,
  peopleInput: 'planner-people-input',
  aestheticOption: (v) => `planner-aesthetic-${v}`,
  locationInput: 'planner-location-input',
  outfitTextarea: 'planner-outfit-textarea',
  intendedUseOption: (v) => `planner-use-${v}`,
  mustHaveTextarea: 'planner-must-have-textarea',
  notesTextarea: 'planner-notes-textarea',
  nameInput: 'planner-name-input',
  emailInput: 'planner-email-input',
  phoneInput: 'planner-phone-input',
  backButton: 'planner-back-button',
  nextButton: 'planner-next-button',
  submitButton: 'planner-submit-button',
  errorText: 'planner-error-text',
  comingSoon: 'planner-coming-soon',
  comingSoonContactLink: 'planner-coming-soon-contact-link',
};

export const BLUEPRINT_PAGE = {
  root: 'blueprint-page',
  generating: 'blueprint-generating-state',
  failed: 'blueprint-failed-state',
  title: 'blueprint-title',
  tagline: 'blueprint-tagline',
  section: (key) => `blueprint-section-${key}`,
  bookNow: 'blueprint-book-now-button',
  contact: 'blueprint-contact-link',
  copyLink: 'blueprint-copy-link-button',
  newPlan: 'blueprint-new-plan-link',
};

export const ADMIN_INTELLIGENCE = {
  tab: 'admin-tab-intelligence',
  table: 'admin-blueprints-table',
  row: (id) => `admin-blueprint-row-${id}`,
  detail: 'admin-blueprint-detail',
  editor: 'admin-blueprint-editor',
  saveButton: 'admin-blueprint-save-button',
  reviewButton: 'admin-blueprint-review-button',
  regenerateButton: 'admin-blueprint-regenerate-button',
  deleteButton: 'admin-blueprint-delete-button',
  viewClientLink: 'admin-blueprint-view-client-link',
  closeButton: 'admin-blueprint-close-button',
};

export const BYOK_SETTINGS = {
  card: 'admin-byok-card',
  providerTab: (provider) => `admin-byok-provider-tab-${provider}`,
  activeBadge: (provider) => `admin-byok-active-badge-${provider}`,
  statusBadge: (provider) => `admin-byok-status-badge-${provider}`,
  keyInput: (provider) => `admin-byok-key-input-${provider}`,
  modelSelect: (provider) => `admin-byok-model-select-${provider}`,
  imageModelSelect: (provider) => `admin-byok-image-model-select-${provider}`,
  saveButton: (provider) => `admin-byok-save-button-${provider}`,
  removeButton: (provider) => `admin-byok-remove-button-${provider}`,
  activateButton: (provider) => `admin-byok-activate-button-${provider}`,
  helpText: 'admin-byok-help-text',
  capabilityBadge: (provider, capability) => `admin-byok-capability-${provider}-${capability}`,
};

export const RESEARCH_KEY_SETTINGS = {
  card: 'admin-research-key-card',
  statusBadge: 'admin-research-key-status-badge',
  keyInput: 'admin-research-key-input',
  modelSelect: 'admin-research-key-model-select',
  saveButton: 'admin-research-key-save-button',
  removeButton: 'admin-research-key-remove-button',
};

export const AI_USAGE = {
  card: 'admin-ai-usage-card',
  monthLabel: 'admin-ai-usage-month-label',
  grandTotal: 'admin-ai-usage-grand-total',
  providerRow: (provider) => `admin-ai-usage-provider-${provider}`,
  modelRow: (provider, model) => `admin-ai-usage-model-${provider}-${model}`,
  empty: 'admin-ai-usage-empty',
};

export const ADMIN_LEADS = {
  tab: 'admin-tab-leads',
  table: 'admin-leads-table',
  row: (id) => `admin-lead-row-${id}`,
  statusFilter: 'admin-leads-status-filter',
  statusSelect: (id) => `admin-lead-status-${id}`,
  blueprintLink: (id) => `admin-lead-blueprint-link-${id}`,
};

export const INTELLIGENCE_ENTRY = {
  navPlan: 'nav-link-plan',
  homeSection: 'home-intelligence-section',
  homeCta: 'home-intelligence-plan-button',
  serviceDetailCta: 'service-detail-plan-button',
  contactCta: 'contact-plan-link',
};

export const GALLERY_FAVORITES = {
  heart: (id) => `gallery-favorite-toggle-${id}`,
  filter: 'gallery-favorites-filter',
  count: 'gallery-favorites-count',
  lightboxHeart: 'lightbox-favorite-button',
  lightboxDownload: 'lightbox-download-button',
  portalCount: (slug) => `client-portal-favorites-count-${slug}`,
  adminButton: (id) => `admin-client-favorites-${id}`,
  adminPanel: 'admin-client-favorites-panel',
};

export const SHOOT_MODE = {
  root: 'shoot-mode-page',
  progress: 'shoot-mode-progress',
  shot: (key) => `shoot-mode-shot-${key}`,
  scene: (i) => `shoot-mode-scene-${i}`,
  notes: 'shoot-mode-notes',
  shareButton: 'shoot-mode-share-button',
  revokeButton: 'shoot-mode-revoke-button',
  resetButton: 'shoot-mode-reset-button',
  backLink: 'shoot-mode-back-link',
  invalid: 'shoot-mode-invalid',
  editorOpen: 'admin-blueprint-shoot-mode-link',
  sectionSelect: 'admin-blueprint-section-select',
  sectionRegenerate: 'admin-blueprint-section-regenerate-button',
  resendEmail: 'admin-blueprint-resend-email-button',
  emailStatus: 'admin-blueprint-email-status',
};
